'use client';

import { useState, type FC, type ReactNode } from 'react';
import { Button } from '../../../components/ui/Button';
import { cn } from '../../../utils/cn';

// WHY: на телефоне редакционный текст главной — несколько экранов до вопросов; до нажатия виден только первый абзац целиком, обрезки посреди заголовка нет; весь текст в разметке
export const WikiClampBox: FC<{ more: string; lead: ReactNode; children: ReactNode }> = ({ more, lead, children }) => {
  const [expanded, setExpanded] = useState(false);
  return (
    <div className="flex flex-col items-start gap-1">
      {lead}
      <div className={cn('w-full', !expanded && 'max-lg:hidden')}>{children}</div>
      {!expanded && (
        <Button
          type="button"
          variant="tertiary"
          size="s"
          onClick={() => setExpanded(true)}
          className="min-h-10 bg-transparent px-0 text-[15px] font-medium text-accent-blue lg:hidden"
        >
          {more}
        </Button>
      )}
    </div>
  );
};
